<template>
  <div class="evolution-sheet-caracteristics">
    <div class="row">
      <sui-filter-bar :multiFilterData="filterInputList"
                      :multiFilterEvents="filterEvents"
                      :selectionInfo="filterSelectionInfo">
      </sui-filter-bar>

      <div class="col-xs-12 doubles" v-if="data.doubles">
        <sui-checkbox v-model="removeDoubles"
                      type="bactADI" size="sm">
          Retirer les doublons
        </sui-checkbox>
      </div>

      <div class="col-xs-12 sheets">
        <table class="table table-responsive">
          <tbody>
            <tr>
              <th></th>
              <th v-for="(fsl, i) in filteredSheetLists"
                  :key="`list-col-${i}`">
                {{ fsl.year }}
              </th>
            </tr>
            <tr>
              <th>
                Fiches filtrées<br>
                <small v-if="appliedFilter">{{ appliedFilter }}</small>
              </th>
              <td v-for="(fsl, i) in filteredSheetLists"
                  :key="`list-count-${i}`">
                {{ fsl.list.length }}
              </td>
            </tr>
            <tr v-if="referenceSheetLists != null">
              <th>
                Fiches utilisées<br>
                <small v-if="caracFilter">{{ caracFilter }}</small>
              </th>
              <td v-for="(fsl, i) in referenceSheetLists"
                  :key="`list-count-${i}`">
                {{ fsl.list.length }}
              </td>
            </tr>
          </tbody>
        </table>
        <btn type="warning" @click="triggerCompute"
             class="compute-button"
             v-show="computingAvailable">
          Recalculer les caractéristiques
        </btn>
      </div>

      <div class="col-xs-12">
        <tabs>
          <tab v-if="caracteristics && caracteristics.done"
               title="Caractéristique simple">
            <h4>Sélection de la caractéristique</h4>
            <div class="form-group">
              <div class="input-group carac-input">
                <input required
                       ref="input"
                       :id="inputID"
                       tabindex="0"
                       class="form-control"
                       v-model="focus.text"
                       type="text"
                       placeholder="Taper le nom de la caractéristique"
                       autocomplete="off"/>
              </div>
              <typeahead v-model="focus.model"
                         open-on-focus
                         force-select
                         ignore-case
                         :limit="50"
                         :target="`#${inputID}`"
                         :data="focusList"
                         item-key="value"/>
            </div>
            <btn @click="focus.showList = !focus.showList" size="xs">
              Liste complète
            </btn>
            <collapse v-model="focus.showList">
              <table class="table table-responsive table-striped">
                <tbody>
                  <tr v-for="(fl, i) in focusListDisplay"
                      :key="`focus-list-${i}`">
                    <td :class="`focus-list-${fl.style}`">{{ fl.value }}</td>
                  </tr>
                </tbody>
              </table>
            </collapse>
            <hr>
            <modal v-model="computing"
                   :backdrop="false" :dismiss-btn="false" :header="false"
                   size="sm" :footer="false">
              Calcul des caractéristiques
            </modal>
            <div v-if="evolution">
              <sui-evol-carac
                :sources="caracteristics.list"
                :field-info="highlight">
              </sui-evol-carac>
            </div>
          </tab>
          <tab title="Tableau" v-if="arrayData">
            <sui-results-array :data="arrayData"
                               :context="appliedFilter">
            </sui-results-array>
          </tab>
        </tabs>
      </div>
    </div>
  </div>
</template>
<script>
import assert from '@/sui/tools/assert'
import ice from '@/sui/tools/ice'
import spread from '@/sui/tools/spread'
import regions from '@/sui/tools/regions'
import distribution from '@/sui/data/distribution'
import distributionTools from '@/sui/tools/distribution'
import results from '@/sui/data/results'

import suiEvolCarac from '@/sui/components/evolution/caracteristics'
import suiFilterBar from '@/sui/components/filter/filterbar'
import suiResultsArray from '@/sui/components/results/array'
import suiSelector from '@/sui/components/results/selector'
import suiCheckbox from '@/sui/components/checkbox'
import suiDoubles from '@/sui/tools/sheets/doubles'

import { mapGetters } from 'vuex'
import clone from 'clone'

export default {
  name: 'tools-caracteristics-evolution',

  props: {
    data: {
      type: Object,
      required: true
    },
    prefix: {
      type: String,
      default: ''
    }
  },

  data: function () {
    return {
      focus: {
        text: '',
        model: null,
        showList: false
      },
      computing: false,
      filteredSheetLists: null,
      referenceSheetLists: null,
      appliedFilter: null,
      caracFilter: null,
      removeDoubles: this.data.doubles,
      doublesLastComputedState: this.data.doubles
    }
  },

  methods: {
    onListFiltered: function (e) {
      const { filter, lists } = e
      const { sheets } = this.data
      if (lists.length !== sheets.length) {
        return
      }

      const result = []
      for (let i = 0; i !== lists.length; ++i) {
        const fl = lists[i]
        const sl = sheets[i]

        result.push(
          {
            year: sl.year,
            dset: sl.dset,
            dist: sl.dist,
            list: fl
          }
        )
      }
      this.filteredSheetLists = ice.freeze(result)
      this.appliedFilter = filter
    },

    triggerCompute: function () {
      this.referenceSheetLists = this.filteredSheetLists
      this.caracFilter = this.appliedFilter
      this.doublesLastComputedState = this.removeDoubles
    }

  },

  computed: {
    ...mapGetters({
      getListByName: 'surveillances/listByName'
    }),

    arrayData: function () {
      const filteredSheetLists = this.filteredSheetLists
      if (filteredSheetLists == null) {
        return null
      }

      const { datasets, tables } = this.data
      const years = Object.keys(datasets)
      const filterInputList = this.filterInputList
      assert.equals(filteredSheetLists.length, filterInputList.length)
      assert.equals(filterInputList.length, years.length)
      const result = []
      for (let i = 0; i !== filterInputList.length; ++i) {
        const variables = filterInputList[i].variables
        const data = filteredSheetLists[i]
        const year = years[i]
        const table = tables[year]

        result.push(
          {
            year: data.year,
            variables: variables,
            table: table,
            list: data.list,
            dist: data.dist
          }
        )
      }

      return result
    },

    inputID: function () {
      return `evolution-sheet-caracteristics-input-${this._uid}`
    },

    computingAvailable: function () {
      return this.caracFilter !== this.appliedFilter ||
          this.removeDoubles !== this.doublesLastComputedState
    },

    highlight: function () {
      const m = this.focus.model
      const { tables } = this.data
      if (tables == null || m == null) {
        return null
      }

      return {
        field: m.field,
        title: m.title,
        subtitle: m.subtitle,
        displayAllValues: m.displayAllValues
      }
    },

    establishmentData: function () {
      if (this.data == null || this.data.sheets == null) {
        return []
      }

      const result = {}
      const sheets = this.data.sheets
      for (let i = 0; i !== sheets.length; ++i) {
        const sl = sheets[i]
        const el = this.getListByName(parseInt(sl.year))
        result[sl.year] = {}
        for (let j = 0; j !== el.length; ++j) {
          const e = el[j]
          const etbTypeIndex = e.surveillance.establishment.type
          const etbType = results.getEstablishementType(etbTypeIndex) || 'none'
          const f = e.surveillance.establishment.finess
          const ri = regions.indexOf(f)
          const r = regions.filters[ri]
          result[sl.year][e.surveillance.id] = {
            region: r.name,
            regionIndex: ri,
            finess: f,
            etbType: etbType
          }
        }
      }
      return result
    },

    filterInputList: function () {
      if (this.data == null || this.data.sheets == null) {
        return []
      }

      const result = []
      const sheets = this.data.sheets
      for (let i = 0; i !== sheets.length; ++i) {
        const sl = sheets[i]

        const vars = sl.vars.slice()
        vars.push(
          {
            key: 'finess',
            name: 'Finess',
            field: (s) => {
              const id = s[this.data.surveillanceField]
              const e = this.establishmentData[sl.year][id]
              return e == null ? [] : [e.finess]
            },
            exclusive: ['region', 'finess']
          },
          {
            key: 'region',
            name: 'Région',
            field: (s) => {
              const id = s[this.data.surveillanceField]
              const e = this.establishmentData[sl.year][id]
              return e == null ? [] : [e.region]
            },
            exclusive: ['region', 'finess']
          }
        )

        const list = this.removeDoubles
          ? ice.freeze(suiDoubles.filter(sl.list)) : sl.list
        result.push(
          {
            list: list,
            variables: ice.freeze(vars)
          }
        )
      }

      return result
    },

    filterEvents: function () {
      return {
        filter: this.onListFiltered
      }
    },

    filterSelectionInfo: function () {
      return {
        filter: this.appliedFilter
      }
    },

    focusListDisplay: function () {
      const result = []
      const previous = {
        title: '',
        subtitle: ''
      }
      for (let i = 0; i !== this.focusList.length; ++i) {
        const focus = this.focusList[i]
        if (focus.title !== previous.title) {
          result.push({ style: 'title', value: focus.title })
          previous.title = focus.title
          previous.subtitle = ''
        }

        if (focus.subtitle !== previous.subtitle) {
          result.push({ style: 'subtitle', value: focus.subtitle })
          previous.subtitle = focus.subtitle
        }

        result.push({ style: 'value', value: focus.value })
      }
      return result
    },

    focusList: function () {
      if (this.data == null ||
          this.data.datasets == null ||
          this.data.tables == null) {
        return []
      }

      const fieldsByTitles = {}
      const orderedTitles = []
      const keys = {}
      const { datasets, tables } = this.data
      const years = Object.keys(datasets)
      for (let j = years.length - 1; j >= 0; --j) {
        const y = years[j]
        const t = tables[y]

        for (let i = 0; i !== t.length; ++i) {
          const c = t[i]
          const displayAllValues = c.displayAllValues
          let subtitle = ''
          for (let j = 0; j !== c.list.length; ++j) {
            const f = c.list[j]
            if (f.h) {
              subtitle = f.t
              continue
            }
            const previous = keys[f.f]
            if (previous == null) {
              const title = c.title
              const elt = {
                field: clone(f),
                origin: f,
                title: title,
                subtitle: subtitle,
                value: `${f.f} => ${f.t}`,
                displayAllValues: displayAllValues
              }

              const r1 = fieldsByTitles[title]
              if (r1 == null) {
                orderedTitles.push(title)
                const add = {}
                add[subtitle] = [elt]
                fieldsByTitles[title] = add
              } else {
                const r2 = r1[subtitle]
                if (r2 == null) {
                  r1[subtitle] = [elt]
                } else {
                  r2.push(elt)
                }
              }
              keys[f.f] = elt
            } else if (f.v != null) {
              for (let i = 0; i !== f.v.length; ++i) {
                const value = f.v[i]
                const key = value.index != null ? value.index : value.code
                const found = previous.field.v == null || previous.field.v.find(
                  l => (l.index != null ? l.index : l.code) === key
                )
                if (!found) {
                  previous.field.v.push(value)
                }
              }
            }
          }
        }
      }

      const result = []
      for (let i = 0; i < orderedTitles.length; i++) {
        const title = orderedTitles[i]
        const fieldsBySubtitles = fieldsByTitles[title]
        assert.notNull(fieldsBySubtitles)

        for (let j in fieldsBySubtitles) {
          const fields = fieldsBySubtitles[j]

          for (let k = 0; k < fields.length; k++) {
            const f = fields[k]
            result.push(f)
          }
        }
      }
      return ice.freeze(result)
    },

    evolution: function () {
      if (this.data == null ||
          this.highlight == null ||
          this.caracteristics == null ||
          !this.caracteristics.done ||
          this.caracteristics.list == null) {
        return false
      }

      return true
    }
  },

  asyncComputed: {
    caracteristics: {
      get: function () {
        if (this.data == null || this.referenceSheetLists == null) {
          return null
        }

        let iteration = 0
        const result = []
        const list = this.referenceSheetLists
        const vm = this

        const etbRegionKey = `${this.prefix}etbregion`
        const etbTypeKey = `${this.prefix}etbtype`

        return spread(
          () => {
            const l = list[iteration]
            try {
              const dist = distribution(l.dist, l.list, l.year)
              const etbregion = distributionTools.createRep()
              const etbtype = distributionTools.createRep()

              for (let i = 0; i !== l.list.length; ++i) {
                const s = l.list[i]
                const surveillance = s[vm.data.surveillanceField]
                const r = vm.establishmentData[l.year][surveillance]
                assert.notNull(
                  r,
                  `Missing data for surveillance ${surveillance} (${l.year})`
                )
                etbregion.increment(r.regionIndex)
                etbtype.increment(r.etbType)
              }

              dist[etbRegionKey] = etbregion
              dist[etbTypeKey] = etbtype

              result.push({ dset: l.dset, year: l.year, dist: dist })
            } catch (e) {
              vm.$notify({
                type: 'danger',
                title: 'Erreur !',
                duration: 0,
                content: `Une erreur est survenue pendant le calcul des
caractéristiques : ${e}.`
              })

              return {
                end: true,
                final: {
                  done: true,
                  list: null
                }
              }
            }

            iteration += 1
            return {
              end: iteration === list.length,
              final: {
                done: true,
                list: result
              }
            }
          },
          150
        )
      },

      default: null
    }
  },

  watch: {
    referenceSheetLists: function (v) {
      if (v !== null) {
        this.computing = true
      }
    },

    caracteristics: function (c) {
      if (c.done && this.computing) {
        this.computing = false
      }
    }
  },

  components: {
    'sui-evol-carac': suiEvolCarac,
    'sui-filter-bar': suiFilterBar,
    'sui-selector': suiSelector,
    'sui-results-array': suiResultsArray,
    'sui-checkbox': suiCheckbox
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#tools-caracteristics-evolution {
  min-height: 100rem;
}

.compute-button {
  margin-bottom: 1rem;
}

.carac-input {
  width: 100%
}

.sheets, .doubles {
  margin-top: 1rem;
}

.focus-list-title {
  font-weight: bold;
  font-size: 120%;
}

.focus-list-subtitle {
  font-style: italic;
  font-size: 110%;
  text-indent: 2rem;
}

.focus-list-value {
  text-indent: 4rem;
}

.btn-toolbar > .c-checkbox {
  margin-left: 5px;
}
</style>
